import { Palmtree, Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-ocean-dark border-t border-white/10 py-14" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 font-serif text-2xl font-semibold text-white">
              <Palmtree className="w-6 h-6 text-gold" strokeWidth={1.6} />
              L'Échappée CSE
            </div>
            <p className="mt-4 text-sm text-white/60 leading-relaxed max-w-xs">
              L'excellence caribéenne au service de la vitalité et de la cohésion de vos équipes.
              Journée Bien-être du CE • Antilles 4★.
            </p>
          </div>

          <div>
            <h4 className="text-gold text-xs uppercase tracking-[0.2em] font-semibold">Destinations</h4>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              {["Guadeloupe", "Saint-Martin"].map((d) => (
                <li key={d} className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5 text-ocean-lagoon" />{d}</li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-gold text-xs uppercase tracking-[0.2em] font-semibold">Contact</h4>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              <li className="flex items-center gap-2"><Mail className="w-3.5 h-3.5 text-ocean-lagoon" />claudette.lada1004@gmail.com</li>
              <li className="flex items-center gap-2"><Phone className="w-3.5 h-3.5 text-ocean-lagoon" />+590 (0)690 63 43 81</li>
            </ul>
            <button
              onClick={() => document.querySelector("#formulaire-devis")?.scrollIntoView({ behavior: "smooth" })}
              className="mt-5 rounded-full bg-gold hover:bg-gold-hover text-ocean-dark font-semibold px-5 py-2.5 text-sm transition-colors"
              data-testid="footer-cta-button"
            >
              Demander une proposition
            </button>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/45">
          <p>© {new Date().getFullYear()} L'Échappée CSE Antilles. Tous droits réservés.</p>
          <div className="flex items-center gap-4">
            <p>Offre réservée aux CSE, amicales du personnel et directions RH.</p>
            <a href="/espace-leads" className="text-white/45 hover:text-gold transition-colors whitespace-nowrap" data-testid="footer-leads-link">Espace équipe</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
